import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom';
import { AuthProvider } from './hooks/use-auth.js';
import Home from './routes/home.js';
import User from './routes/user.js';
import Booking from './routes/booking.js';
import ProtectedRoute from './routes/protect.js';
import Schedule from './routes/schedule';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route element={<ProtectedRoute isAdmin={true}/>}>
              <Route path="user" element={<User/>}/>
              <Route path="user/:id" element={<Schedule/>}/>
            </Route>
            <Route path='booking' element={<ProtectedRoute><Booking/></ProtectedRoute>}/>
            <Route path='schedule' element={<ProtectedRoute><Schedule/></ProtectedRoute>}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
